<template>
  <div class="control" :class="{'is-expanded': expanded}">
    <label class="label">{{label}}</label>
    <input type="text" v-model="value"
           @focus.prevent="hide = false"
           @blur.prevent="onBlur()"
           @keydown.enter.prevent="choose(current)"
           @keydown.tab="choose(current)"
           @keydown.down.prevent="down()"
           @keydown.up.prevent="up()"
           @input.prevent="current = -1"
           :disabled="disabled"
           class="input" :placeholder="placeholder"/>
    <table v-show="!hideSuggestion()"
           class="table table--suggestions is-bordered is-narrow is-hoverable is-fullwidth is-striped">
      <tr v-for="(item, index) in matches()"
          @click.prevent="choose(index)"
          @mousedown.prevent=""
          :class="{'is-selected': index === current}">
        <td>{{prop !== '' ? item[prop] : item}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'Suggest',
    props: {
      placeholder: {
        type: String,
        default: 'Yellow, red, blue...'
      },
      label: {
        type: String,
        required: true
      },
      model: {},
      list: {
        type: Array,
        required: true
      },
      prop: {
        type: String,
        default: ''
      },
      expanded: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        hide: true,
        value: '',
        current: -1
      }
    },
    created: function () {
      if (this.model) {
        this.value = this.prop !== '' && this.model[this.prop] !== undefined
          ? this.model[this.prop]
          : this.model
      }
    },
    watch: {
      model: function (newer, older) {
        this.value = newer
      }
    },
    methods: {
      matches () {
        let value = (this.value || '').toString().toLowerCase()
        return this.list.filter(item => {
          if (this.prop !== '' && item[this.prop] !== undefined) {
            return item[this.prop].toString().toLowerCase().indexOf(value) !== -1
          } else {
            return item.toString().toLowerCase().indexOf(value) !== -1
          }
        })
      },
      up () {
        if (this.current > 0) {
          this.current--
        } else {
          this.current = 0
        }
      },
      down () {
        if (this.current < this.matches().length - 1) {
          this.current++
        } else {
          this.current = this.matches().length - 1
        }
      },
      onBlur () {
        this.hide = true
        let index = this.matches.length ? this.matches.indexOf(this.value) : -1
        this.choose(index)
      },
      choose (i) {
        if (i !== -1) {
          const matches = this.matches()
          this.value = this.prop !== '' ? matches[i][this.prop] : matches[i]
          this.$emit('choosed', this.value)
          this.$emit('choosedAsObject', matches[i])
        }
        this.hide = true
        return true
      },
      hideSuggestion () {
        return (
          this.matches().length === 1 && (
            (this.prop !== '' && this.matches()[0][this.prop] === this.value) ||
            (this.prop === '' && this.matches()[0] === this.value)
          )
        ) || this.hide
      }
    }
  }
</script>

<style scoped lang="scss">
  .table--suggestions {
    position: absolute;
    z-index: 5;
  }
</style>



// WEBPACK FOOTER //
// src/components/actions/Suggest.vue